import {
    ChangeDetectionStrategy,
    Component,
    ViewChild,
} from '@angular/core';
  import { Router } from '@angular/router';
  import { SettingsService, _HttpClient } from '@delon/theme';
  import { NzNotificationService } from 'ng-zorro-antd/notification';
  import { FcwidgetService } from 'src/app/core/util/fcwidget.service';
  import { AppService } from 'src/app/shared/services/app.service';
  import { SharedModule } from 'src/app/shared/shared.module';
  
  @Component({
    selector: 'global-license-notification',
    templateUrl: './global-license-notification.component.html',
    styleUrls: ['./global-license-notification.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [SharedModule]
  })
  export class GlobalLicenseNotificationComponent {
    @ViewChild('template') template!: any;

    get planLink() {
      return `/account/subscription/subscribe/${this.settings.user['company']['tenantId']}`;
    }

    notification: any = {};
    license: any = {};
    isOnTrial: boolean = false;

    constructor(
      private readonly appSrv: AppService,
      private readonly settings: SettingsService,
      private readonly fcWidget: FcwidgetService,
      private readonly notificationSrv: NzNotificationService,
      private readonly http: _HttpClient,
      private readonly router: Router
    ) {
      this.http.get('api/license/mylicense').subscribe(result => {
        this.license = result;
        this.isOnTrial = result.license.isTrialKey;

        if (
          (this.isOnTrial && result.daysLeft >= 0) ||
          (!this.isOnTrial && result.daysLeft >= -7 && result.daysLeft <= 0)
        ) {
          this.notification = this.notificationSrv.template(this.template, {
            nzKey: 'trial-notification',
            nzPlacement: 'top',
            nzDuration: 0,
            nzStyle: {
              display: 'flex',
              width: '3800px'
              //bottom: '50px',
              //right: '50%',
              // transform: 'translateX(-50%)'
            }
          });
        }
      });
    }

    navigateToPlan() {
      this.notificationSrv.remove();
      this.router.navigateByUrl(this.planLink);
    }

    openLiveChat() {
      this.notificationSrv.remove();
      this.fcWidget.open();
    }

    closePrompt() {
      this.notificationSrv.remove();
    }
  }